export enum ContractsActionType {
  FETCH_CONTRACTS = 'FETCH_CONTRACTS'
}
